import { gql } from 'apollo-boost';
import { useMutation } from '../';

export const mergeIndicator = gql`
  mutation mergeIndicator (
    $targetId: Int!,
    $indicatorList: String!,
  ) {
  mergeIndicator(
    targetId: $targetId,
    indicatorList: $indicatorList
  ) {
      success
      id    
    }
  }
`;

export function useMergeIndicator() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(mergeIndicator, variables, () => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    });
  };
  return { data, isLoading, run };
}
